<template>
    <div class="flex items-center gap-2">
        <AuditTimestamp :date="props.data.created_at"></AuditTimestamp>
        <img
            :src="props.data.user_avatar"
            :alt="props.data.user_name"
            class="w-4 h-4 rounded-full aspect-square"
            onerror="this.onerror=null;this.src='/default-images/avatar.png';this.style.backgroundImage = 'none';"
        />
        {{ props.data.user_name }} play a video in
        {{ details.video_group_name }}/{{ details.video_title }}.
        <div v-if="details.watch_time">
            Watch time: {{ formatTime(details.watch_time) }}
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
const props = defineProps(["data"]);
const details = computed(() => JSON.parse(props.data.details));

function formatTime(time) {
    time = Math.round(time);
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
}
</script>
